import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const initState = {
  loading: 0,
  error: null
}

export default {
  namespaced: true,
  state: () => initState,
  mutations,
  actions,
  getters
}
